import { forwardRef } from 'react'
import { Link, type LinkProps } from 'react-router'
import { useLocalePath } from '@/lib/i18n/localePath'

/**
 * Drop-in replacement for react-router's <Link> that prefixes app-internal
 * `to` paths with the active `/:lang` segment (none for the default locale
 * `da`). External/absolute URLs (http…, mailto:, tel:, #hash) and non-string
 * `to` values pass through untouched so we only rewrite in-app navigation.
 *
 * This keeps the user inside their chosen locale as they navigate, which the
 * localization EPIC requires ("switcher updates content live").
 */
export const LocaleLink = forwardRef<HTMLAnchorElement, LinkProps>(
  function LocaleLink({ to, ...rest }, ref) {
    const withLocale = useLocalePath()
    const isInternalPath =
      typeof to === 'string' && to.startsWith('/') && !to.startsWith('//')
    const resolved = isInternalPath ? withLocale(to) : to
    return <Link ref={ref} to={resolved} {...rest} />
  },
)
